
import { namespace } from "vuex-class";
import { Component, Vue } from "vue-property-decorator";

import { Alert } from "@/store/alerts";

const Alerts = namespace("alerts");

@Component
export default class HasAlerts extends Vue {
  protected alerts: Alert[] = [];

  @Alerts.Action("flash")
  private flashGlobal!: (alert: Alert) => void;

  @Alerts.Action("get")
  private getGlobal!: () => Promise<Alert[]>;

  protected flash(alert: Alert, opts: { global: boolean } = { global: false }) {
    if (opts.global) this.flashGlobal(alert);
    this.alerts.splice(0, 1, alert);
  }

  async mounted() {
    this.alerts = await this.getGlobal();
  }
}
